import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Notification } from '../models';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(
    private _toastrService: ToastrService
  ) { }

  public showErrorNotification(notification: Notification): void {
    this._toastrService.error(notification.message, notification.title, {
      timeOut: 5000
    });
  }

  public showNotification(notification: Notification): void {
    this._toastrService.show(notification.message, notification.title, {
      timeOut: 5000
    });
  }

  public showInfoNotification(notification: Notification): void {
    this._toastrService.info(notification.message, notification.title, {
      timeOut: 5000
    });
  }

  public showSuccessNotification(notification: Notification): void {
    this._toastrService.success(notification.message, notification.title, {
      timeOut: 5000
    });
  }

  public showWarningNotification(notification: Notification): void {
    this._toastrService.warning(notification.message, notification.title, {
      timeOut: 5000
    });
  }
}
